<template lang="pug">
  div.wrap-module-catalyst.f.fh
    div.catalyst-content
      div.wrap-icon.f.fc.mb8
        v-avatar(size="120").mb8
          v-img(:src="user.iconPhotoURL")
      span.block.text-center.fz16.bold.mb6 {{user.displayName}}
      span.block.text-center.fz14.mb6 ライセンス取得年月日：{{certifiedDateLabel}}
      a(:href="adressURL" target="brank").block.fz14.mb16.text-center {{license.address}}
      span.block.text-center.fz14 {{user.profile ? user.profile : 'プロフィールがありません'}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-catalyst {
  padding-top: $header_height;
  min-height: 100vh;
  .catalyst-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
  }
}
</style>

<script>
import { format } from 'date-fns'

export default {
  components: {
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    license: {
      type: Object,
      required: true
    }
  },
  computed: {
    certifiedDateLabel () {
      return format(this.user.certifiedAt.toDate(), 'yyyy/MM/dd')
    },
    adressURL () {
      return `https://etherscan.io/address/${this.license.address}`
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
